import { render, staticRenderFns } from "./AppSectionMedalTableCalendar.vue?vue&type=template&id=5423ec52&"
import script from "./AppSectionMedalTableCalendar.vue?vue&type=script&lang=js&"
export * from "./AppSectionMedalTableCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports